'use es6';

import trackingClient from './client';
export var createTracker = trackingClient.createTracker;